// import { useState } from 'react'
import Image from 'next/image'
import clsx from 'clsx'

import { speakers } from './utils'

/* assets */
// import { ReactComponent as DownIcon } from 'public/assets/icons/down.svg'

/* styling */
import styles from './_.module.css'

function ElevateSpeakers(): JSX.Element {
  // const [allSpeakersVisible, setAllSpeakersVisible] = useState(false)
  // const initialSpeakersCount = 8

  // const handleShowAllSpeakers = () => {
  //   setAllSpeakersVisible(true)
  // }

  return (
    <section className="max-width-container | py-16 lg:py-20" id="speakers">
      <div className="grid lg:grid-cols-12 gap-4 lg:gap-8 items-center justify-between | mb-12 lg:mb-24">
        <h2 className="font-heading text-4xl lg:text-5xl font-semibold | lg:col-start-1 lg:col-end-5">
          Meet the
          <span className={clsx(styles.textGradient1)}> Speakers</span>
        </h2>
      </div>

      <div className="grid gap-10 grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 | mb-18">
        {speakers
          // .slice(0, allSpeakersVisible ? speakers.length : initialSpeakersCount)
          .map(speaker => {
            return <SpeakerCard key={speaker.name} data={speaker} />
          })}
      </div>

      {/* {!allSpeakersVisible && (
        <div className="flex | mt-10">
          <button
            className="font-medium text-[#070425] text-xl | flex items-center gap-2 | mx-auto py-2 | border-b"
            onClick={handleShowAllSpeakers}
          >
            Show all speakers <DownIcon />
          </button>
        </div>
      )} */}
    </section>
  )
}

function SpeakerCard({ data }: { data: (typeof speakers)[0] }) {
  return (
    <div className="flex items-center gap-6 md:gap-8 md:flex-col">
      <div
        className="flex items-center justify-center | rounded-full | w-22 h-22 md:w-[15rem] md:h-[15rem]"
        style={{
          background:
            'linear-gradient(180deg, #8DEFF6 0%, rgba(233, 236, 239, 0) 100%)'
        }}
      >
        <Image
          className="rounded-full | w-20 h-20 md:w-56 md:h-56"
          style={{
            background: 'linear-gradient(178deg, #9AABF4 -9%, #FFA3CC 120%)'
          }}
          src={data.avatar}
          alt={data.name}
          width="226"
          height="226"
        />
      </div>

      <div className="md:text-center">
        <p className="font-heading text-xl lg:text-2xl font-semibold text-blue-60 | mb-0.5 md:mb-1.5">
          {data.name}
        </p>
        <p className="text-sm lg:text-base text-gray-70 | mb-0.5 md:mb-1.5">
          {data.designation}
        </p>
        {data.company && (
          <p className="text-sm lg:text-base font-semibold text-gray-70">
            {data.company}
          </p>
        )}
      </div>
    </div>
  )
}

export default ElevateSpeakers
